let interval = setInterval(function () {
  let apElements = document.querySelector('#avpoptions-container__v2');
  if (apElements){
     document.querySelectorAll('.choice-list-variatnt-title span.money').forEach(item => {
        item.innerHTML = item.innerHTML.replace("(", "").replace(")", "").replace("+", "")
    })
  }
}, 100);

function forceQuitInterval(){
  clearInterval(interval);
}

setTimeout(forceQuitInterval, 10000);

let interval2 = setInterval(function() {
  let apElements = document.querySelector('#avpoptions-container__v2');
  if(apElements) {
    let moneyElements = document.querySelectorAll('#avpoptions-container__v2 .money');
    if(moneyElements && moneyElements.length) {
      for(let moneyElem of moneyElements) {
        moneyElem.innerHTML = moneyElem.innerHTML.replace(".00", "");
      }
    }
    clearInterval(interval2);
  }
}, 100);